import React, { useState } from 'react';

// Mirrors Rate My Trade's ShareModal (RateMyTradePage.js) — same dark,
// blurred-backdrop card, same three-button grid. Kept as a separate
// component since Market's own screens are plain CSS, not this inline-style
// dark treatment, which is deliberately reserved for shareable-card moments.
const ff = "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif";

async function downloadBlob(url, filename) {
  try {
    const res = await fetch(url, { credentials: 'include' });
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
  } catch (e) {
    window.open(url, '_blank');
  }
}

const ShareTicketModal = ({ open, onClose, positionId, assetName, assetPath, pnlPct }) => {
  const [copying, setCopying] = useState(false);
  const [downloading, setDownloading] = useState(false);
  if (!open) return null;

  const imageUrl = `${window.location.origin}/api/market/positions/${positionId}/ticket.png`;
  const assetUrl = `${window.location.origin}${assetPath}`;
  const isProfit = pnlPct >= 0;
  const pctStr = `${isProfit ? '+' : ''}${pnlPct.toFixed(1)}%`;

  const copyLink = () => {
    navigator.clipboard.writeText(assetUrl);
    setCopying(true);
    setTimeout(() => setCopying(false), 2000);
  };

  const download = async () => {
    if (downloading) return;
    setDownloading(true);
    const slug = (assetName || 'ticket').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    await downloadBlob(imageUrl, `${slug}-ticket.png`);
    setDownloading(false);
  };

  const tweet = () => {
    const text = isProfit
      ? `${assetName} ${pctStr}. Booked on The Market — Fantasy Taco's paper desk.`
      : `${assetName} ${pctStr}. Booked. Live to trade again on The Market.`;
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(assetUrl)}`,
      '_blank'
    );
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100,
        background: 'rgba(0,0,0,0.78)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        overflowY: 'auto',
        animation: 'mkShareFadeIn 0.18s ease',
      }}
    >
      <style>{`
        @keyframes mkShareFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes mkShareSlideUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#0E0E10',
          borderRadius: '24px',
          border: '1px solid rgba(255,255,255,0.1)',
          maxWidth: '420px',
          width: '100%',
          padding: '32px',
          position: 'relative',
          fontFamily: ff,
          animation: 'mkShareSlideUp 0.24s cubic-bezier(0.16,1,0.3,1)',
        }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            border: 'none',
            background: 'rgba(255,255,255,0.06)',
            color: 'rgba(255,255,255,0.6)',
            fontSize: '16px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: ff,
          }}
        >
          ×
        </button>

        <div
          style={{
            fontSize: '11px',
            fontWeight: 500,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.3)',
            marginBottom: '6px',
          }}
        >
          Share
        </div>
        <div style={{ fontSize: '22px', fontWeight: 700, letterSpacing: '-0.02em', color: '#FFFFFF', marginBottom: '20px' }}>
          The ticket, booked.
        </div>

        <div
          style={{
            background: '#000',
            borderRadius: '14px',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.06)',
            marginBottom: '20px',
            aspectRatio: '1 / 1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={imageUrl} alt={`${assetName} ticket`} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px' }}>
          {[
            { label: copying ? 'Copied' : 'Copy link', action: copyLink },
            { label: downloading ? 'Saving…' : 'Download', action: download },
            { label: 'Post to X', action: tweet, primary: true },
          ].map(({ label, action, primary }) => (
            <button
              key={label}
              type="button"
              onClick={action}
              style={{
                padding: '14px 12px',
                borderRadius: '12px',
                border: primary ? 'none' : '1px solid rgba(255,255,255,0.12)',
                background: primary ? '#FFFFFF' : 'rgba(255,255,255,0.06)',
                color: primary ? '#000' : 'rgba(255,255,255,0.85)',
                fontFamily: ff,
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShareTicketModal;
